import * as yup from 'yup';

import { Model as UserModel } from 'models/user/interface';
import { USER_ROLES, USER_STATUS } from 'constants/index';

import { endpoint, EndpointError } from '../endpoint';
import { ValidationShape } from '../validation';

export type GetByRoleParams = {
  role: USER_ROLES;
  search?: string;
  limit?: string;
  status?: USER_STATUS;
};
export type GetByRoleResult = { users: UserModel[] };
export type GetByRoleError = EndpointError;

export const getByRoleParamsSchema = yup.object().shape({
  role: yup.string(),
  search: yup.string(),
  status: yup.string().oneOf(Object.values(USER_STATUS)),
  limit: yup.string(),
} as unknown as ValidationShape<GetByRoleParams>);

export const getByRole = endpoint<GetByRoleParams, GetByRoleResult, GetByRoleError>({
  method: 'GET',
  url: () => `/user/by-role`,
});
